import {numUtil} from './num';
import type {TradePair, SpotPair, KlineBar, ws} from '@/types';

export const klineUtil = {
  convertToBar(raw: ws.KlineItemRaw, tradePair: TradePair, priceScale0?: number): KlineBar {
    const {pricePrecision} = tradePair;
    const priceScale = priceScale0 || priceScale0 === 0 ? priceScale0 : genPriceScale(tradePair);
    // "timestamp", "interval", "last_close", "open", "high", "low", "close", "volume", "turnover", "symbol"
    const lastPriceEp = Number(raw[2]);
    const openPriceEp = Number(raw[3]);
    // 解决刚开盘last_close的价格为0导致k线open展示为0的问题
    const priceEp = lastPriceEp > 0 ? lastPriceEp : openPriceEp;
    return {
      close: calcNumber(Number(raw[6]), pricePrecision, priceScale),
      high: calcNumber(Number(raw[4]), pricePrecision, priceScale),
      low: calcNumber(Number(raw[5]), pricePrecision, priceScale),
      open: calcNumber(priceEp, pricePrecision, priceScale),
      time: raw[0] * 1e3,
      volume: calcVolume(Number(raw[7]), tradePair),
    };
  },
};

function genPriceScale(tradePair: TradePair) {
  return tradePair.type === 'Spot' ? (tradePair as SpotPair).quoteQtyScale : tradePair.priceScale;
}

function calcNumber(priceEp, pricePrecision, priceScale) {
  return Number(numUtil.floor(priceEp, pricePrecision, priceScale));
}

function calcVolume(volumeEv, tradePair: TradePair) {
  if (tradePair.type === 'Spot') {
    const {baseQtyPrecision, baseQtyScale} = tradePair as SpotPair;
    return calcNumber(volumeEv, baseQtyPrecision, baseQtyScale);
  }
  return volumeEv;
}
